import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
    const containers = document.querySelectorAll(".wp-block-ifdigital-if-cast-container");

    containers.forEach((container) => {
        const sections = gsap.utils.toArray(container.querySelectorAll(".wp-block-ifdigital-if-cast-member"));

        if (!container) {
            console.error("Container element not found");
            return;
        }

        if (sections.length === 0) {
            console.error("No cast member elements found");
            return;
        }

        // Berechne die Gesamtbreite basierend auf den Sektionen
        const totalWidth = sections.length * window.innerWidth;

        // Setze Container-Breite und fixe Container-Höhe
        gsap.set(container, {
            width: `${totalWidth}px`,
            height: `${container.offsetHeight}px`, // Verwende die initiale Höhe des Containers
        });

        // Scroll Animation
        gsap.to(container, {
            x: -(totalWidth - window.innerWidth), // Verschiebe horizontal
            ease: "none",
            scrollTrigger: {
                trigger: container,
                pin: true,
                start: "center center",
                scrub: 0.25, // Kleineren Wert für schnellere Animation
                end: () => `+=${totalWidth - window.innerWidth}`,
                markers: false,
                pinSpacing: true,
            },
        });

        // Modalbox Funktionalität
        const modal = document.createElement("div");
        modal.classList.add("modal");
        modal.innerHTML = `
            <div class="modal-content">
                <span class="modal-close">✕</span>
                <div class="modal-body"></div>
            </div>
        `;
        document.body.appendChild(modal);

        const modalClose = modal.querySelector(".modal-close");
        const modalBody = modal.querySelector(".modal-body");

        // Eventlistener für das Schließen der Modalbox
        modalClose.addEventListener("click", () => {
            modal.style.display = "none";
        });

        // Klick außerhalb der Modalbox zum Schließen
        window.addEventListener("click", (event) => {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        });

        // Füge Eventlistener zu den Beschreibungselementen hinzu
        const descriptions = container.querySelectorAll(".wp-block-ifdigital-if-cast-member--description");

        descriptions.forEach((description) => {
            const longDescription = description.dataset.longDescription;
            if (longDescription && longDescription.trim() !== "") {
                const button = document.createElement('button');
                button.innerText = 'Mehr erfahren';
                button.addEventListener("click", () => {
                    modalBody.textContent = longDescription;
                    modal.style.display = "block";
                });
                description.appendChild(button);
            }
        });
    });
});